import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, max } from 'vee-validate/dist/rules'
import { isRegistrationEmailAvailable, isEmailSignedUpForNotification } from '@/services/HttpSvc'

extend('required', {
  ...required,
  message: 'This field is required.',
})

extend('max', {
  ...max,
  message: 'Max of 500 characters.',
})

extend('maxLines', {
  validate: (value, args) => value.split(/\r\n|\r|\n/).filter((n) => n != "").length <= args.length,
  params: ['length'],
  message: 'Max of {length}',
})

extend('maxWords', {
  validate: (value, args) => value.split(/\b\w+\b/).length - 1 <= args.length,
  params: ['length'],
  message: 'Max of {length} words',
})

extend('displayMaxWords', {
  validate: () => true, // Always passes - this is just for display purposes
  params: ['length'],
})

extend('email', {
  ...email,
  message: 'Please enter a valid email address.',
})

extend('emailRegistrationUnique', {
  validate: value => isRegistrationEmailAvailable(value),
  message: 'You already have an account with us, please login.',
})

extend('emailNotificationSignupUnique', {
  validate: value => isEmailSignedUpForNotification(value),
  message: 'You have already registered for notifications with this email address.',
})

extend('password', {
  validate: (value, { other }) => value === other,
  message: 'The password confirmation does not match.',
  params: [{ name: 'other', isTarget: true }],
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
}
